import React, { useRef, useState } from "react";
import {
  I2cInput,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { migrationType } from "./FieldsListingLabels";
const NewMigrationForm = ({ control, handleValueChanges, methods, errors }) => {
  return (
    <>
      <div className="forms-instance">
        <div className="single-field-wrapper mb-16">
          <Controller
            name="pi_type_of_migration"
            control={control}
            render={({ field }) => (
              <I2cRadioGroup
                label=" Please specify the type of migration"
                {...field}
                value={methods.watch("pi_type_of_migration")}
                name="pi_type_of_migration"
                required
                onI2cChange={(e) => {
                  field.onChange(e);
                  methods.trigger();
                  handleValueChanges();
                }}
              >
                {migrationType.map((cp, index) => (
                  <I2cRadioButton
                    key={index}
                    name="pi_type_of_migration"
                    value={cp.toLocaleLowerCase().replace(" ", "-")}
                  >
                    {cp}
                  </I2cRadioButton>
                ))}
              </I2cRadioGroup>
            )}
          />
          <ErrorMessage
            show={
              errors.pi_type_of_migration &&
              methods.formState.touchedFields.pi_type_of_migration
                ? true
                : false
            }
            message={errors.pi_type_of_migration?.message ?? "Invalid input"}
          />
        </div>
        {methods.getValues("pi_type_of_migration") !== null && (
          <div className="single-field-wrapper halfWidth">
            <Controller
              name="pi_type_of_processor_name"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  label="Please specify the bank or processor name"
                  className="single-input-field"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  placeholder="Specify name"
                  size="large"
                  required
                  name={"pi_type_of_processor_name"}
                />
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pi_type_of_processor_name &&
                methods.formState.touchedFields.pi_type_of_processor_name
                  ? true
                  : false
              }
              message={
                errors.pi_type_of_processor_name?.message ?? "Invalid input"
              }
            /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default NewMigrationForm;
